<script>
import Label from "./Label.vue";
import Switches from "vue-switches";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: Boolean,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    updateValue: {
      type: Function,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
    shouldShowInfoText() {
      // Only show info text when the toggle is disabled
      return this.item.disabled === true && this.item.infoText;
    },
  },
  components: {
    Label,
    Switches,
  },
  data() {
    return {
      value: this.item_value,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
    };
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    d_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
  },
};
</script>
<template>
  <div :class="{ 'd-none': item.displayOn && !d_check }">
    <Label :item="item" />
    <div class="flex">
      <switches
        v-model="value"
        type-bold="false"
        color="info"
        class="mt-2"
        :disabled="
          item.disabled ||
          (this.$route.params.categoryName == 'globalupdate'
            ? false
            : selectedItem?.additionalProp1?.global
            ? true
            : false)
        "
      ></switches>
      <div class="px-10" v-if="item.featuredIcon">
        <i class="ri-star-fill mr-2 font-size-20" style="color: gold"></i>
      </div>
    </div>
    
    <div v-if="shouldShowInfoText" class="text-muted small mt-2">
      {{ item.infoText }}
    </div>

    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>
